// OSS配置
export const OSS_CONFIG = {
  DOMAIN: 'https://topdf-site-source.oss-cn-chengdu.aliyuncs.com',
  // 由于资源直接在根目录，不需要assets前缀
  ASSETS_PREFIX: ''
};

// 获取资源完整URL
export const getAssetUrl = (path) => {
  return `${OSS_CONFIG.DOMAIN}${OSS_CONFIG.ASSETS_PREFIX}${path}`;
};
